import { notification } from 'antd';
import { TemplateV2 } from '../../../api/pushRenderPdfTemplateConfig';

export const checkIfImageSizeExceedAndNotify = (file: File) => {
    if (file.size > 300000) {
        notification.error({
            message:
                'Upload failed! Image size greater than 300KB. Please use online image compressor to reduce size.',
            duration: 5,
            placement: 'topRight',
        });
        return true;
    }
    return false;
};

export const setTemplateFieldIfEmpty = (template?: TemplateV2) => {
    if (!template) {
        return {
            header_img: undefined,
            footer_img: undefined,
            margin_left: '1.27cm',
            margin_right: '1.27cm',
            header_height: '3cm',
            footer_height: '6cm',
            page_size: 'A4',
        };
    }
    return template;
};
